import React from "react";
import { Table,Card } from "react-bootstrap";
import { Link } from "react-router-dom";

function Packages() {
  return (
    <>
    <Table responsive className="d-none d-md-block" striped bordered>
      <thead>
        <tr>
          <th></th>
          <th>BASIC PLAN(FREE)</th>
          <th>STANDARD PLAN($2/MONTH) + 20% vat</th>
          <th>STANDARD PLAN($20/YEAR) + 20% vat</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>FREE SIGNUP</td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
        </tr>
        <tr>
          <td>FREE BUSINESS LISTING</td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
        </tr>
        <tr>
          <td>VIEW HUB ANALYTICS</td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
        </tr>
        <tr>
          <td>COVER IMAGE VISIBILITY</td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
        </tr>
        <tr>
          <td>RATINGS AND REVIEWS</td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
        </tr>
        <tr>
          <td>BUSINESS DESCRIPTION</td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
        </tr>
        <tr>
          <td>VISIBILITY OF BUSINESS LOCATION</td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
        </tr>
        <tr>
          <td>DETAILED BUSINESS DESCRIPTION</td>
          <td>
            <i className="fas fa-times text-danger fs-24" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
        </tr>
        <tr>
          <td>CHAT WITH USERS</td>
          <td>
            <i className="fas fa-times text-danger fs-24" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
        </tr>
        <tr>
          <td>VISIBILITY OF SOCIAL NETWORK HANDLES</td>
          <td>
            <i className="fas fa-times text-danger fs-24" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
        </tr>
        <tr>
          <td>VISIBILITY OF PHONE NUMBER</td>
          <td>
            <i className="fas fa-times text-danger fs-24" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
        </tr>
        
        <tr>
          <td>VISIBILITY OF EMAIL</td>
          <td>
            <i className="fas fa-times text-danger fs-24" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
        </tr>
        <tr>
          <td>VISIBILITY OF BUSINESS WEBSITE</td>
          <td>
            <i className="fas fa-times text-danger fs-24" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
        </tr>
        <tr>
          <td>WORKING HOUR DISPLAYED</td>
          <td>
            <i className="fas fa-times text-danger fs-24" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
        </tr>
        <tr>
          <td>LOGO IMAGE VISIBILITY</td>
          <td>
            <i className="fas fa-times text-danger fs-24" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
          <td>
            <i className="fas fa-check fs-24 text-success" />
          </td>
        </tr>
        <tr>
          <td>GALLERY</td>
          <td>UP TO 1 IMAGE</td>
          <td>UP TO 5 IMAGES</td>
          <td>UP TO 5 IMAGES</td>
        </tr>
        <tr>
          <td>SUBSCRIPTION CANCELLATION</td>
          <td>ANYTIME</td>
          <td>ANYTIME</td>
          <td>AFTER 1 YEAR</td>
        </tr>
        <tr>
          <td style={{ border: "none" }}></td>
          <td className="" style={{ border: "none" }}>
            <Link to="/add-listing/basic" className="text-decoration-none">
              <button className="btn btn-danger btn-lg addbtn border-0">
                select
              </button>
            </Link>
          </td>
          <td style={{ border: "none" }}>
            <Link
              to="/add-listing/standard-month"
              className="text-decoration-none"
            >
              <button className="btn btn-danger btn-lg addbtn border-0">
                select
              </button>
            </Link>
          </td>
          <td style={{ border: "none" }}>
            <Link
              to="/add-listing/standard-year"
              className="text-decoration-none"
            >
              <button className="btn btn-danger btn-lg addbtn border-0">
                select
              </button>
            </Link>
          </td>
        </tr>
      </tbody>
    </Table>
    <div className="d-block d-md-none">
<Card className="mb-3">
  <Card.Body>
    <Card.Title className="heading-plan text-center">BASIC PLAN(FREE)</Card.Title>
    <div className="d-flex my-3 justify-content-center">
            <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    FREE SIGNUP
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    FREE BUSINESS LISTING
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    VIEW HUB ANALYTICS
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    COVER IMAGE VISIBILITY
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    RATINGS AND REVIEWS
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    BUSINESS DESCRIPTION
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    VISIBILITY OF BUSINESS LOCATION
    </Card.Text>
    </div> 
    <div className="d-flex my-3 justify-content-center">
    <i className="fas fa-times mr-2 text-danger fs-24" />
    <Card.Text>
    DETAILED BUSINESS DESCRIPTION
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas fa-times mr-2 text-danger fs-24" />
    <Card.Text>
    CHAT WITH USERS
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas fa-times mr-2 text-danger fs-24" />
    <Card.Text>
    VISIBILITY OF SOCIAL NETWORK HANDLES
    </Card.Text>
    </div> <div className="d-flex my-3 justify-content-center">
    <i className="fas fa-times mr-2 text-danger fs-24" />
    <Card.Text>
    VISIBILITY OF PHONE NUMBER
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas fa-times mr-2 text-danger fs-24" />
    <Card.Text>
    VISIBILITY OF EMAIL
    </Card.Text>
    </div> 
    <div className="d-flex my-3 justify-content-center">
    <i className="fas fa-times mr-2 text-danger fs-24" />
    <Card.Text>
    VISIBILITY OF BUSINESS WEBSITE
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas fa-times mr-2 text-danger fs-24" />
    <Card.Text>
    WORKING HOUR DISPLAYED
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas fa-times mr-2 text-danger fs-24" />
    <Card.Text>
    LOGO IMAGE VISIBILITY
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <Card.Text>
    GALLERY:
    </Card.Text>
    <span className="ml-2">UP TO 1 IMAGE</span>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <Card.Text>
    SUBSCRIPTION CANCELLATION:
    </Card.Text>
    <span className="ml-2">ANYTIME</span>
    </div>
    <div className="d-flex justify-content-center">
    <Link to="/add-listing/basic" className="text-decoration-none">
              <button className="btn btn-danger btn-lg addbtn border-0">
                select
              </button>
            </Link>
        </div>
  </Card.Body>
</Card>
<Card className="mb-3">
  <Card.Body>
    <Card.Title className="heading-plan text-center">STANDARD PLAN($2/MONTH) + 20% vat</Card.Title>
    <div className="d-flex my-3 justify-content-center">
            <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    FREE SIGNUP
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    FREE BUSINESS LISTING
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    VIEW HUB ANALYTICS
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    COVER IMAGE VISIBILITY
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    RATINGS AND REVIEWS
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    BUSINESS DESCRIPTION
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    DETAILED BUSINESS DESCRIPTION
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    CHAT WITH USERS
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    VISIBILITY OF SOCIAL NETWORK HANDLES
    </Card.Text>
    </div> <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    VISIBILITY OF PHONE NUMBER
    </Card.Text>
    </div> <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    VISIBILITY OF BUSINESS LOCATIONN
    </Card.Text>
    </div> <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    VISIBILITY OF EMAIL
    </Card.Text>
    </div> 
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    VISIBILITY OF BUSINESS WEBSITE
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    WORKING HOUR DISPLAYED
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    LOGO IMAGE VISIBILITY
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <Card.Text>
    GALLERY:
    </Card.Text>
    <span className="ml-2">UP TO 5 IMAGES</span>
    </div>
    <div className="d-flex flex-wrap my-3 justify-content-center">
    <Card.Text>
    SUBSCRIPTION CANCELLATION:
    </Card.Text>
    <span className="ml-2">ANYTIME</span>
    </div>
    <div className="d-flex justify-content-center">
    <Link
              to="/add-listing/standard-month"
              className="text-decoration-none"
            >
              <button className="btn btn-danger btn-lg addbtn border-0">
                select
              </button>
            </Link>
        </div>
  </Card.Body>
</Card>
<Card>
  <Card.Body>
    <Card.Title className="heading-plan text-center">STANDARD PLAN($20/YEAR) + 20% vat</Card.Title>
    <div className="d-flex my-3 justify-content-center">
            <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    FREE SIGNUP
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    FREE BUSINESS LISTING
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    VIEW HUB ANALYTICS
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    COVER IMAGE VISIBILITY
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    RATINGS AND REVIEWS
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    BUSINESS DESCRIPTION
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    DETAILED BUSINESS DESCRIPTION
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    CHAT WITH USERS
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    VISIBILITY OF SOCIAL NETWORK HANDLES
    </Card.Text>
    </div> <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    VISIBILITY OF PHONE NUMBER
    </Card.Text>
    </div> <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    VISIBILITY OF BUSINESS LOCATIONN
    </Card.Text>
    </div> <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    VISIBILITY OF EMAIL
    </Card.Text>
    </div> 
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    VISIBILITY OF BUSINESS WEBSITE
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    WORKING HOUR DISPLAYED
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <i className="fas mr-2 fa-check fs-24 text-success" />
    <Card.Text>
    LOGO IMAGE VISIBILITY
    </Card.Text>
    </div>
    <div className="d-flex my-3 justify-content-center">
    <Card.Text>
    GALLERY:
    </Card.Text>
    <span className="ml-2">UP TO 5 IMAGES</span>
    </div>
    <div className="d-flex flex-wrap my-3 justify-content-center">
    <Card.Text>
    SUBSCRIPTION CANCELLATION:
    </Card.Text>
    <span className="ml-2">AFTER 1 YEAR</span>
    </div>
    <div className="d-flex justify-content-center">
    <Link
              to="/add-listing/standard-year"
              className="text-decoration-none"
            >
              <button className="btn btn-danger btn-lg addbtn border-0">
                select
              </button>
            </Link>
        </div>
  </Card.Body>
</Card>
    </div>
    </>
  );
}

export default Packages;
